/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Card,
  CardContent,
  CardDescription,
  DatePicker,
  Badge,
  Combobox,
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { useGetOrdersByRoute, useGetRostersByRoute } from "utils/apis/home.api";
import { process } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { formatDate } from "date-fns";
import { UserContext } from "utils/reducers/user";
import { useGetRouteTeams } from "utils/apis/lookups.api";
import { CircleX } from "lucide-react";
import { saveFilters } from "utils/actions/user";
import { getLink } from "utils/helper";

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export default function OrdersByRoutes() {
  const user = useContext(UserContext);

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [locations, setLocations] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [filters, setFilters] = useState<any>(
    user?.filters?.["route-services"] || {},
  );

  const { data: routeList } = useGetRouteTeams();

  const { data: allOrders, isFetching: loadingRoutes } = useGetRostersByRoute({
    cashCenterId: user.CashCenterId,
    routeNo: filters?.routeNo?.id || "",
    fromDate: formatDate(
      filters?.fromDate?.id || new Date(),
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
    toDate: formatDate(
      filters?.toDate?.id || new Date(),
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const {
    mutate: getOrdersByRoute,
    data: routeOrders,
    isError: routeOrdersError,
    isPending: loadingRequests,
  } = useGetOrdersByRoute();

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(user.dispatch, {
      ...user.filters,
      "route-services": updatedFilter,
    });
  };

  const onFromDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        fromDate: { name: `From: ${formatDate(value, "PPP")}`, id: value },
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        "route-services": {
          ...filters,
          fromDate: { name: `From: ${formatDate(value, "PPP")}`, id: value },
        },
      });
    }
  };

  const onToDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        toDate: { name: `To: ${formatDate(value, "PPP")}`, id: value },
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        "route-services": {
          ...filters,
          toDate: { name: `To: ${formatDate(value, "PPP")}`, id: value },
        },
      });
    }
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };

  const handleFiltersUpdate = (key: string, val: any) => {
    const { ...remainingFilters } = filters;
    setFilters({
      ...(key === "customer" ? remainingFilters : filters),
      [key]: JSON.parse(val),
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "route-services": {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(val),
      },
    });
  };

  const handleRoute = (val: string) => {
    handleFiltersUpdate("routeNo", val);
  };

  const expandChange = (event: any) => {
    event.dataItem.expanded = Boolean(event.value);

    const index = event.dataIndex;
    setActiveIndex(index);
    if (!event.value || event.dataItem.detail) {
      setLocations([...locations]);
      return;
    }

    getOrdersByRoute({
      cashCenterId: user.CashCenterId,
      operationDate: formatDate(
        event.dataItem?.operationDate || new Date(),
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo: event.dataItem?.routeNo,
      shift: "morning",
    });
  };

  function DetailComponent(props: any) {
    const data = props.dataItem.details;

    function ShowOrderIDCell({ dataItem }: any) {
      const { requestId, jobNo } = dataItem;

      return (
        <td>
          {dataItem.serviceType ? (
            <Link
              to={getLink(dataItem?.serviceType)}
              state={{ requestId, jobNo, isReRoute: true }}
            >
              {dataItem.orderId}
            </Link>
          ) : (
            dataItem.orderId
          )}
        </td>
      );
    }

    if (data) {
      return (
        <Grid data={data}>
          <Column field="orderId" cell={ShowOrderIDCell} title="Order Id" />
          <Column field="jobNo" title="Job No" />
          <Column field="locationName" title="Location Name" />
          <Column field="locationId" title="Location Id" />
          <Column field="routeDate" title="Route Date" />
          <Column field="departure" title="Departure" />
          <Column field="arrival" title="Arrival" />
          <Column field="collected" title="Collected" />
          <Column field="delivered" title="Delivered" />
        </Grid>
      );
    }

    return (
      <div
        style={{
          height: "50px",
          width: "100%",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
          }}
        >
          <div className="k-loading-image" />
        </div>
      </div>
    );
  }

  useEffect(() => {
    if (routeOrders) {
      const data: any = locations?.slice();

      if (activeIndex || activeIndex === 0) {
        data[activeIndex].details = routeOrders;
      }
      setLocations(data);
    }

    if (routeOrdersError) {
      const data: any = locations?.slice();
      if (activeIndex || activeIndex === 0) {
        data[activeIndex].details = [];
      }
      setLocations(data);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeOrders, routeOrdersError]);

  useEffect(() => {
    if (allOrders?.length) {
      setLocations(allOrders);
    } else {
      setLocations([]);
    }
  }, [allOrders]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Orders By Route</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <div className="max-w-[300px] w-full flex items-center gap-2">
                <label
                  htmlFor="toDate"
                  className="font-medium whitespace-nowrap"
                >
                  Route No:
                </label>
                <Combobox
                  placeholder="Select Route"
                  value={JSON.stringify(filters?.routeNo) || ""}
                  data={routeList?.map((item) => ({
                    value: JSON.stringify({
                      name: `(${item?.routeNo}) ${item?.description}`,
                      id: item?.routeNo,
                    }),
                    label: `(${item?.routeNo}) ${item?.description}`,
                  }))}
                  setValue={handleRoute}
                />
              </div>
              <div className="max-w-[300px] w-full flex items-center gap-2">
                <label
                  htmlFor=" fromDate"
                  className="font-medium whitespace-nowrap"
                >
                  From Date:
                </label>
                <DatePicker
                  placeholder="Select From Date"
                  selectedDate={filters?.fromDate?.id || new Date()}
                  onSelectDate={onFromDateChanged}
                />
              </div>
              <div className="max-w-[300px] w-full flex items-center gap-2">
                <label
                  htmlFor="toDate"
                  className="font-medium whitespace-nowrap"
                >
                  To Date:
                </label>
                <DatePicker
                  placeholder="Select To Date"
                  selectedDate={filters?.toDate?.id || new Date()}
                  onSelectDate={onToDateChanged}
                />
              </div>
            </div>
            <div className="flex gap-2 flex-wrap mb-3 items-center">
              {Object.entries(filters).map(([key, val]: any, i) =>
                val.id ? (
                  <Badge
                    variant="secondary"
                    className="gap-3 pr-1 cursor-pointer"
                    key={i}
                  >
                    {val?.name}{" "}
                    <CircleX
                      onClick={() => {
                        handleClearFilter(key);
                      }}
                    />
                  </Badge>
                ) : null,
              )}
            </div>
            <div className="border-b mb-3 bg-accent" />
            {loadingRequests || loadingRoutes ? (
              <div className="k-loading-mask">
                <span className="k-loading-text">Loading</span>
                <div className="k-loading-image" />
                <div className="k-loading-color" />
              </div>
            ) : null}
            <Grid
              className="text-xs"
              data={process(locations || [], {
                ...dataState,
                skip: 0,
              })}
              {...dataState}
              onDataStateChange={onDataStateChange}
              sortable
              filterable
              size="small"
              detail={DetailComponent}
              expandField="expanded"
              onExpandChange={expandChange}
            >
              <Column field="routeNo" title="Route No" />
              <Column field="operationDate" title="Date" />
              <Column field="actualStart" title="Start Time" />
              <Column field="actualEnd" title="End Time" />
              <Column field="vanRegistrationNo" title="Van Registration" />
              <Column field="distance" title="Distance" />
            </Grid>
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}
